import React, {Component} from "react";
import {CreditTransactionsHeader} from "./../components/CreditTransactionsHeader";
import "./../../../assests/styles/CreditLines.css";
import CreditTransactionApiHandler from "./../CreditTransactionApiHandler.js";
import CreditTransactionsItem from "./creditTransactionsItem.js";
import CreditTransactionsIngestion from "./CreditTransactionsIngestion.js";
import FileSaver from "file-saver";
import Loading from "react-loading-bar";
import "react-loading-bar/dist/index.css";
import qs from 'query-string';
import Dialog from "@material-ui/core/Dialog";

export default class CreditTransactions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            BZID: null,
            status: [],
            fromDate: null,
            toDate: null,
            creditPortal: null,
            dueDateFrom: null,
            dueDateTo: null,
            CreditTransactionLines: null,
            loading: false,
            pageNumber: 1,
            showErrorModal: null,
            error: null,
            bzIdFromDexter: null,
            productNameFromDexter: null,
            showLoader: false
        };
        this.showSelectedFiltes = true;
        this.limit = 50;
        this.offset = 0;
        this.handleSearch = this.handleSearch.bind(this);
        this.handleDumdDownload = this.handleDumdDownload.bind(this);
        this.calculatePageNumber = this.calculatePageNumber.bind(this);
        this.getFilter = this.getFilter.bind(this);
    }

    componentWillMount() {
        var businsessId = qs.parse(this.props.location.search).bzid ? qs.parse(this.props.location.search).bzid : JSON.parse(localStorage.getItem("searched_bzid"));
        var product = qs.parse(this.props.location.search).productName;
        if (businsessId || product) {
            this.setState({
                bzIdFromDexter: businsessId,
                productNameFromDexter: product
            })
        }
    }

    componentDidMount() {
        var businsessId = qs.parse(this.props.location.search).bzid ? qs.parse(this.props.location.search).bzid : JSON.parse(localStorage.getItem("searched_bzid"));
        console.log("businessId is ", businsessId);
        var product = qs.parse(this.props.location.search).productName;

        if (businsessId || product) {
            this.setState({
                bzIdFromDexter: businsessId,
                productNameFromDexter: product
            })
        }

        if (businsessId) {
            document.getElementById("credit_transaction_input").value = businsessId;
            this.handleSearch(businsessId, null, null, null, product, null, null, 0);
        }

        var lines = document.getElementById("creditTransactionLines");
        if (lines) {
            var filterHeight = document.getElementById("topFilter").offsetHeight;
            var headerHeight = document.getElementById("header").offsetHeight;
            lines.style.height = window.innerHeight - (filterHeight + headerHeight) + 'px';
        }
    }

    showErrorMessageModal = () => {
        return (
            <div>
                <Dialog open={this.state.showErrorModal} aria-labelledby="responsive-dialog-title" maxWidth="sm"
                        classes={{paperWidthSm: "wider-dialoge"}}>
                    <div style={{padding: "1em"}}>
                        <div>
                            <div className="row">
                                <div className="col-md-12">
                                    Error: <div
                                    style={{color: "red"}}>{" " + JSON.stringify(this.state.error["error"])} </div>
                                </div>
                            </div>
                            <div className="row" style={{paddingRight: "2em"}}>
                                <button className="btn btn-jt-ops pull-right" onClick={() => {
                                    this.setState({showErrorModal: false})
                                }}>
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }

    handleSearch(bzid, selectedStatuses, fromDateCreated, toDateCreated, creditPortal, dueDateFrom, dueDateTo, offestVal) {
        this.showSelectedFiltes = true;
        this.setState({loading: true});
        this.offset = offestVal;
        var filtersArray = this.getFilter(bzid, selectedStatuses, fromDateCreated, toDateCreated, creditPortal, dueDateFrom, dueDateTo);
        var request = {
            filters: filtersArray,
            limit: this.limit,
            offset: this.offset
        };
        if (offestVal === 0) {
            this.setState({pageNumber: 1});
        }
        CreditTransactionApiHandler.getCreditTransactiipns(request)
            .then(
                function (resp) {
                    console.log(resp);
                    this.setState({
                        CreditTransactionLines: resp
                    });
                }.bind(this)
            ).catch((error) => {
            this.setState({
                error: error.error,
                showErrorModal: true,
            });
        })
            .finally(
                function () {
                    this.setState({
                        loading: false
                    });
                }.bind(this)
            );
    }

    getFilter(bzid, selectedStatuses, fromDateCreated, toDateCreated, creditPortal, dueDateFrom, dueDateTo) {
        var emptyString = "";
        if (fromDateCreated) {
            var fromDateCreatedEpoch = new Date(fromDateCreated);
            fromDateCreatedEpoch.setHours(0, 0, 0, 0);
            fromDateCreatedEpoch = fromDateCreatedEpoch.getTime();
            console.log("fromDateCreatedEpoch " + fromDateCreatedEpoch);
        }
        if (toDateCreated) {
            var toDateCreatedEpoch = new Date(toDateCreated);
            toDateCreatedEpoch.setHours(23, 59, 59, 0);
            toDateCreatedEpoch = toDateCreatedEpoch.getTime();
            console.log("toDateCreatedEpoch " + toDateCreatedEpoch);
        }
        if (dueDateFrom) {
            var dueDateFromEpoch = new Date(dueDateFrom);
            dueDateFromEpoch.setHours(0, 0, 0, 0);
            dueDateFromEpoch = dueDateFromEpoch.getTime();
        }
        if (dueDateTo) {
            var dueDateToEpoch = new Date(dueDateTo);
            dueDateToEpoch.setHours(23, 59, 59, 0);
            dueDateToEpoch = dueDateToEpoch.getTime();
        }
        this.setState({
            BZID: bzid,
            status: selectedStatuses,
            fromDate: fromDateCreated,
            toDate: toDateCreated,
            creditPortal: creditPortal,
            dueDateFrom: dueDateFrom,
            dueDateTo: dueDateTo
        });
        var filtersArray = {
            fromDate: fromDateCreatedEpoch ? (fromDateCreatedEpoch === emptyString ? null : fromDateCreatedEpoch) : null,
            toDate: toDateCreatedEpoch ? (toDateCreatedEpoch === emptyString ? null : toDateCreatedEpoch) : null,
            bzId: bzid ? (bzid === emptyString ? null : bzid.trim()) : null,
            piStatusList: selectedStatuses ? (selectedStatuses === emptyString ? null : selectedStatuses) : null,
            productName: creditPortal ? (creditPortal === emptyString ? null : creditPortal.trim()) : null,
            fromDueDate: dueDateFromEpoch ? (dueDateFromEpoch === emptyString ? null : dueDateFromEpoch) : null,
            toDueDate: dueDateToEpoch ? (dueDateToEpoch === emptyString ? null : dueDateToEpoch) : null
        };
        return filtersArray;
    }

    handleDumdDownload(bzid, selectedStatuses, fromDateCreated, toDateCreated, creditPortal, dueDateFrom, dueDateTo) {
        this.showSelectedFiltes = false;
        this.setState({showLoader: true});
        var filtersArray = this.getFilter(bzid, selectedStatuses, fromDateCreated, toDateCreated, creditPortal, dueDateFrom, dueDateTo);
        var request = {
            filters: filtersArray
        };
        CreditTransactionApiHandler.getCreditTransactionDump(request)
            .then(function (response) {
                response.data.blob().then(function (data) {
                    var blob = new Blob([data], {
                        type: response.mime
                    });
                    FileSaver.saveAs(blob, response.name);
                });
            })
            .catch((error) => {
                this.setState({
                    error: error.error,
                    showErrorModal: true,
                });
            })
            .finally(
                function () {
                    this.setState({
                        showLoader: false
                    });
                }.bind(this)
            );
    }

    calculatePageNumber(fromMethod) {
        // debugger;
        var offsetVal = this.offset;
        var limit = this.limit;
        if (fromMethod === "next") {
            offsetVal += limit;
        } else {
            offsetVal -= limit;
        }

        this.offset = offsetVal;
        this.setState({
            pageNumber: offsetVal / limit + 1
        });
        var state = this.state;
        this.handleSearch(state.BZID, state.status, state.fromDate, state.toDate, state.creditPortal, state.dueDateFrom, state.dueDateTo, offsetVal);
    }

    chequeNumberUpdated = r => {
        const {CreditTransactionLines} = this.state;
        for (let i in CreditTransactionLines) {
            if (CreditTransactionLines[i].paymentInstrument.paymentInstrumentId === r.id) {
                CreditTransactionLines[i].paymentInstrument.paymentReferenceId = r.newChequeNumber;
                break;
            }
        }
        this.setState({CreditTransactionLines});
    }

    showCreditTransactionLines() {
        var lines;
        if (this.state.CreditTransactionLines) {
            lines = this.state.CreditTransactionLines.map((line, index) => {
                return (
                    <div key={index}>
                        <CreditTransactionsItem data={line} chequeNumberUpdated={this.chequeNumberUpdated}/>
                    </div>
                );
            });
        }
        return lines;
    }

    showFilterStatus() {
        let status;
        if (this.state.status) {
            status = this.state.status.map((statusItem, index) => {
                return <div key={index} className="border-for-status-box inline">{statusItem}</div>;
            });
        }
        return <div style={{padding: "0 10px"}}>{status}</div>;
    }

    render() {
        return (
            <div>
                <div id="topFilter">
                    <CreditTransactionsHeader handleSearch={this.handleSearch}
                                              handleDumdDownload={this.handleDumdDownload}
                                              bzIdFromDexter={this.state.bzIdFromDexter}
                                              productNameFromDexter={this.state.productNameFromDexter}/>
                </div>
                <div id="creditTransactionLines" style={{overflow: "scroll"}}>
                    {this.state.loading ? this.showLoadingScreen() : this.showPage()}
                    {this.state.showErrorModal ? this.showErrorMessageModal() : null}
                </div>
            </div>
        );
    }

    showPage() {
        return (
            <div>
                {this.loderDisplay()}
                <div style={{padding: "0 15px"}}>
                    <div className="row" style={{marginTop: "20px"}}>
                        <div className="col-md-9" style={{padding: "10px"}}>
                            {this.showSelectedFiltes ? this.showFilterStatus() : null}
                        </div>
                        <div className="col-md-3">
                            <CreditTransactionsIngestion/>
                        </div>
                    </div>
                </div>
                <div style={{padding: "20px"}}>{this.showCreditTransactionLines()}</div>
                {(this.state.CreditTransactionLines && this.state.CreditTransactionLines.length > 0) ?
                    <div>{this.pagenation()}</div> : null
                }
            </div>
        );
    }

    pagenation() {
        return (
            <div style={{padding: "15px 0 40px 0", textAlign: "center"}}>
                <button
                    type="button"
                    className={this.state.pageNumber < 2 ? "btn btn-primary disabled" : "btn btn-primary active"}
                    onClick={() => {
                        this.calculatePageNumber("prev");
                    }}
                >
                    Previous page
                </button>
                <button className="btn btn-default" disabled="disabled" style={{margin: "0 5px"}}>
                    {this.state.pageNumber}
                </button>
                <button
                    type="button"
                    className={this.state.creditLines && this.state.creditLines.length < 50 ? "btn btn-primary disabled" : "btn btn-primary active"}
                    onClick={() => {
                        this.calculatePageNumber("next");
                    }}
                >
                    Next page
                </button>
            </div>
        );
    }

    showLoadingScreen() {
        return (
            <div className="no-jobs-to-assign">
                <div className="lds-hourglass"/>
            </div>
        );
    }

    loderDisplay() {
        return (
            <div>
                <Loading show={this.state.showLoader} color="#ffa000"/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/creditTransactions/components/creditTransactions.js